import React, { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../../../hooks/useAuth';
import { Loading } from '../../Common/StyledComponents';

const ProtectedRoute = memo(({ children, roles = [] }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Loading type="fullscreen" size="large" tip="Authenticating..." />
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate 
        to="/login" 
        state={{ from: location.pathname }} 
        replace 
      />
    );
  }

  // Check role based authorization 
  // if (roles.length > 0 && user && !roles.includes(user.role)) {
  //   return (
  //     <Navigate 
  //       to="/unauthorized" 
  //       state={{ requiredRoles: roles, userRole: user.role }} 
  //       replace 
  //     />
  //   );
  // }

  return children;
});

ProtectedRoute.displayName = 'ProtectedRoute';

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
};

ProtectedRoute.defaultProps = {
  roles: [],
};

export default ProtectedRoute;